import { localizedTitle } from "@/lib/i18n/ssrSeo";
import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import { queryOptions } from "@tanstack/react-query";
import { getPublicUpcomingPicks } from "@/lib/publicPicks.functions";
import { hubJsonLd } from "@/lib/picksJsonLd";

const picksQuery = queryOptions({ queryKey: ["public-upcoming-picks"], queryFn: () => getPublicUpcomingPicks(), staleTime: 5 * 60_000 });
import TodayPredictions from "@/pages/TodayPredictions";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/predictions/today")({
  loader: ({ context }) => context.queryClient.ensureQueryData(picksQuery),
  head: ({ loaderData }) => {
    const L = localizedTitle("/predictions/today", { title: "Football Predictions Today: Free Betting Tips & Picks | Statlign", description: "Free football predictions today: AI betting tips for Premier League, La Liga, Serie A and more, with odds, confidence scores and the reasoning behind every pick." });
    return {
    meta: [
      { title: L.title },
      { name: "keywords", content: seoFor({ topics: ["footballPredictions", "predictions", "nigeria"] }).meta },
      { name: "description", content: L.description },
      { property: "og:title", content: L.title },
      { property: "og:type", content: "website" },
      { property: "og:description", content: L.description },
      { name: "twitter:title", content: L.title },
      { name: "twitter:description", content: L.description },
    ],
    scripts: hubJsonLd({ path: "/predictions/today", name: "Today's football predictions", description: "Football predictions and betting tips for matches kicking off today.", picks: (loaderData ?? []).filter((p) => new Date(p.kickoff_time).getTime() - Date.now() < 36 * 3600_000) }),
  };
  },
  component: () => (
    <MainLayout>
      <TodayPredictions />
    </MainLayout>
  ),
});
